import { useRebookSliceHeader } from "@b2bportal/core-flights-rebook";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Trans } from "@hopper-b2b/i18n";
import { Typography, TypographyTypeEnum } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./RebookSliceHeader.module.scss";
import type { RebookSliceHeaderProps } from "./types";
import { CoreFlightsRebookComponent } from "~core-flights-rebook/components/rebook-component";
import { useFlightsRebookStyles } from "~core-flights-rebook/styles";

const COMPONENT_KEY = CoreFlightsRebookComponent.RebookSliceHeader;

export const RebookSliceHeader = (props: RebookSliceHeaderProps) => {
  const styles = useFlightsRebookStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className, children } = props;
  const { text } = useRebookSliceHeader(props);

  return (
    <div className={clsx(block, className)}>
      <Typography
        type={TypographyTypeEnum.Heading}
        size="xs"
        weight="light"
        className={cn("flight-info")}
      >
        <Trans
          i18nKey="core-flights.rebook.summary.slice-title"
          components={{
            bold: <span className={cn("bold")} />,
          }}
          values={{
            originName: text.origin.name,
            originCode: text.origin.code,
            destinationName: text.destination.name,
            destinationCode: text.destination.code,
            departureDate: text.departureDate,
          }}
        />
      </Typography>
      <Typography
        type={TypographyTypeEnum.Paragraph}
        size="sm"
        variant="secondary"
        className={cn("travelers-info")}
      >
        {text.travelers}
      </Typography>
      {text.cabinClass != null ? (
        <Typography
          type={TypographyTypeEnum.Paragraph}
          size="sm"
          variant="secondary"
          className={cn("cabin-class-info")}
        >
          {text.cabinClass}
        </Typography>
      ) : null}
      {children}
    </div>
  );
};
